export default __webpack_public_path__ + "media/inspired-bg.7773d324.png";